import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Shield } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { useCookieConsent } from '../context/CookieConsentContext';

const CookieBanner = () => {
  const { showBanner, acceptAll, acceptNecessary } = useCookieConsent();

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-dark-secondary/95 backdrop-blur-xl border border-white/10 p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex items-center justify-center w-12 h-12 bg-gold/10 rounded-sm shrink-0">
                <Cookie size={24} className="text-gold" weight="light" />
              </div>
              
              <div className="flex-1">
                <h3 className="font-serif text-lg md:text-xl text-white mb-2">
                  Cookie-Einstellungen
                </h3>
                <p className="text-sm text-white/70 mb-4 leading-relaxed">
                  Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
                  Einige Cookies sind notwendig für den Betrieb der Website, während andere uns helfen, 
                  die Website und das Nutzererlebnis zu verbessern.{' '}
                  <a href="http://511816786.swh.strato-hosting.eu/datenschutz/" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-light underline">
                    Mehr erfahren
                  </a>
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button
                    onClick={acceptAll}
                    className="bg-gold text-black hover:bg-gold-light font-medium uppercase tracking-wide text-sm px-6 py-3 rounded-sm"
                    data-testid="cookie-accept-all"
                  >
                    <Shield size={18} weight="light" className="mr-2" />
                    Alle akzeptieren
                  </Button>
                  <Button
                    onClick={acceptNecessary}
                    variant="outline"
                    className="border-white/20 text-white hover:bg-white hover:text-black font-medium uppercase tracking-wide text-sm px-6 py-3 rounded-sm"
                    data-testid="cookie-accept-necessary"
                  >
                    Nur notwendige
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
